module.exports = __webpack_public_path__ + "img/shutterstock_2368579157-2-768x512.ddaaf4fd.jpg";